export const parseUrlToLabel = (url: string) => url.replace("http://", "").replace("https://", "");
